import { Box } from '@chakra-ui/react';
import React from 'react';

import type { TxsSocketType } from './socket/types';
import type { AddressFromToFilter } from 'types/api/address';
import type { Transaction, TransactionsSortingField, TransactionsSortingValue } from 'types/api/transaction';
import type { PaginationParams } from 'ui/shared/pagination/types';

import { TableTopBorder } from 'toolkit/chakra/table';
import { ACTION_BAR_HEIGHT_DESKTOP } from 'ui/shared/ActionBar';
import DataListDisplay from 'ui/shared/DataListDisplay';
import getNextSortValue from 'ui/shared/sort/getNextSortValue';

import useMergeWithRiskAssessment from './aiAnalysis/useMergeWithRiskAssessment';
import useDescribeTxs from './noves/useDescribeTxs';
import TxsTable from './TxsTable';

const SORT_SEQUENCE: Record<TransactionsSortingField, Array<TransactionsSortingValue>> = {
  value: [ 'value-desc', 'value-asc', 'default' ],
  fee: [ 'fee-desc', 'fee-asc', 'default' ],
  block_number: [ 'block_number-asc', 'default' ],
};

type Props = {

  pagination: PaginationParams;
  showBlockInfo?: boolean;
  socketType?: TxsSocketType;
  currentAddress?: string;
  filter?: React.ReactNode;
  filterValue?: AddressFromToFilter;
  enableTimeIncrement?: boolean;
  top?: number;
  items?: Array<Transaction>;
  isPlaceholderData: boolean;
  isError: boolean;
  setSorting: (value: TransactionsSortingValue) => void;
  sort: TransactionsSortingValue;
};

const TxsContent = ({
  pagination,
  showBlockInfo = true,
  socketType,
  currentAddress,
  enableTimeIncrement,
  top,
  items,
  isPlaceholderData,
  isError,
  setSorting,
  sort,
}: Props) => {
  // const isMobile = useIsMobile();

  const onSortToggle = React.useCallback((field: TransactionsSortingField) => {
    const value = getNextSortValue<TransactionsSortingField, TransactionsSortingValue>(SORT_SEQUENCE, field)(sort);
    setSorting(value);
  }, [ sort, setSorting ]);

  const itemsWithTranslation = useDescribeTxs(items, currentAddress, isPlaceholderData);
  const itemsWithRiskAsssessment = useMergeWithRiskAssessment(itemsWithTranslation);

  const content = itemsWithRiskAsssessment ? (
    <>
      { /* <Box hideFrom="lg">
        <TxsList
          showBlockInfo={ showBlockInfo }
          socketType={ socketType }
          isLoading={ isPlaceholderData }
          enableTimeIncrement={ enableTimeIncrement }
          currentAddress={ currentAddress }
          items={ itemsWithRiskAsssessment }
        />
      </Box> */ }
      <TableTopBorder/>
      <Box overflow={{ base: 'scroll', lg: 'visible' }} mx={{ lg: 6, base: 4 }}
      >
        <TxsTable
          txs={ itemsWithRiskAsssessment }
          sort={ sort }
          onSortToggle={ onSortToggle }
          showBlockInfo={ showBlockInfo }
          socketType={ socketType }
          top={ top || (pagination.isVisible ? ACTION_BAR_HEIGHT_DESKTOP : 0) }
          currentAddress={ currentAddress }
          enableTimeIncrement={ enableTimeIncrement }
          isLoading={ isPlaceholderData }
        />
      </Box>
    </>
  ) : null;

  // const actionBar = isMobile ? (
  //   <TxsHeaderMobile
  //     mt={ -6 }
  //     sorting={ sort }
  //     setSorting={ setSorting }
  //     paginationProps={ pagination }
  //     filterComponent={ filter }
  //     linkSlot={ currentAddress ? (
  //       <AddressCsvExportLink
  //         address={ currentAddress }
  //         params={{ type: 'transactions', filterType: 'address', filterValue }}
  //         isLoading={ pagination.isLoading }
  //       />
  //     ) : null
  //     }
  //   />
  // ) : null;

  return (
    <DataListDisplay
      isError={ isError }
      itemsNum={ itemsWithTranslation?.length }
      emptyText="There are no transactions."
      // actionBar={ actionBar }
    >
      { content }
    </DataListDisplay>
  );
};

export default TxsContent;
